import storeEditSagas from './common/sagas';

export default [
  ...storeEditSagas,
];
